export default "__VITE_ASSET__BV6ZE$Rp__"